import { render } from "./WithAllowHalf.vue?vue&type=template&id=0f1a50b5"
import script from "./WithAllowHalf.vue?vue&type=script&lang=ts"
export * from "./WithAllowHalf.vue?vue&type=script&lang=ts"
script.render = render

export default script